export default function () { return { localeError: () => undefined }; }